import { useEffect, useRef, useCallback } from "react";

const TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
const WARNING_MS = 2 * 60 * 1000;  // warn 2 minutes before

export function useAutoLogout(user, onLogout) {
  const timerRef = useRef(null);
  const warningRef = useRef(null);
  const warningShownRef = useRef(false);

  const resetTimer = useCallback(() => {
    if (!user) return;
    clearTimeout(timerRef.current);
    clearTimeout(warningRef.current);
    warningShownRef.current = false;

    // Warning at 28 minutes
    warningRef.current = setTimeout(() => {
      if (warningShownRef.current) return;
      warningShownRef.current = true;
      const stay = window.confirm(
        "You've been inactive for 28 minutes. Click OK to stay logged in, or Cancel to log out now."
      );
      if (!stay) {
        onLogout();
      } else {
        // Reset full timer if they chose to stay
        resetTimer();
      }
    }, TIMEOUT_MS - WARNING_MS);

    // Auto logout at 30 minutes
    timerRef.current = setTimeout(() => {
      onLogout();
    }, TIMEOUT_MS);
  }, [user, onLogout]);

  useEffect(() => {
    if (!user) return;

    const events = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click"];
    const handleActivity = () => resetTimer();

    events.forEach(e => window.addEventListener(e, handleActivity, { passive: true }));
    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, handleActivity));
      clearTimeout(timerRef.current);
      clearTimeout(warningRef.current);
    };
  }, [user, resetTimer]);
}